"use strict";
/**
 * Canonical score label bands — single source of truth across all surfaces.
 *
 * A1 rule: when lowConfidence is true and the numeric score would produce
 * "Strong" or "Exceptional", return "Technically compliant" instead — the
 * score reflects hygiene checks only, not market performance.
 *
 * Conformance: FixMySEO_Scoring_Conformance_Handoff.md §4 Phase A, tasks A1 + A2.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScoreLabel = getScoreLabel;
exports.getLabelTone = getLabelTone;
/**
 * Maps a 0–100 score to a display label.
 *
 * @param score        Pillar or overall score (0–100).
 * @param lowConfidence  When true and band would be Strong/Exceptional,
 *                     returns "Technically compliant" (A1 override).
 */
function getScoreLabel(score, lowConfidence = false) {
    const band = scoreToBand(score);
    if (lowConfidence && (band === 'Exceptional' || band === 'Strong')) {
        return 'Technically compliant';
    }
    return band;
}
function scoreToBand(score) {
    if (score >= 90)
        return 'Exceptional';
    if (score >= 75)
        return 'Strong';
    if (score >= 50)
        return 'Developing';
    if (score >= 30)
        return 'Needs work';
    return 'Critical';
}
function getLabelTone(label) {
    switch (label) {
        case 'Exceptional': return 'green';
        case 'Strong': return 'emerald';
        case 'Technically compliant': return 'amber';
        case 'Developing': return 'amber';
        case 'Needs work': return 'orange';
        case 'Critical': return 'red';
    }
}
//# sourceMappingURL=labelBands.js.map